module.exports = __webpack_public_path__ + "img/sort-amount-down-alt.49c5bf62.svg";